import { render, staticRenderFns } from "./ShippingStatusBadge.vue?vue&type=template&id=99c9cc16&scoped=true"
import script from "./ShippingStatusBadge.vue?vue&type=script&lang=js"
export * from "./ShippingStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./ShippingStatusBadge.vue?vue&type=style&index=0&id=99c9cc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c9cc16",
  null
  
)

export default component.exports